import * as dateUtil from '@/util/date';

angular
  .module('inspinia')
  .factory('holidaysService', function (agenciesService, authoritiesService, attributesService) {
    let data = {
      // 祝日情報
      holidays: [],
    };

    // Getters

    const getHolidays = () => {
      return data.holidays;
    };

    /**
     * @params date?: string | Date
     * @returns boolean
     */
    const isHoliday = (date) => {
      return dateUtil.isHoliday(data.holidays, date);
    };

    // Mutations

    const setHolidays = (holidays) => {
      data.holidays = holidays;
    };

    return {
      ...data,
      getHolidays,
      setHolidays,
      isHoliday,
    };
  });
